module.exports = __webpack_public_path__ + "img/ddwu_gallery5.8b23b119.jpg";